'use client'

import React, {memo} from 'react'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import Divider from '@mui/material/Divider'
import Link from 'next/link'
import useTranslation from '../util/translations/useTranslation'
import {
    ROUTE_BLOG,
    ROUTE_HOME,
    ROUTE_LANG_CONTACT,
    ROUTE_LANG_COURSES,
    ROUTE_LANG_FITNESS,
    ROUTE_LANG_IMPRINT,
    ROUTE_LANG_PRICING,
    ROUTE_LANG_PRIVACY,
    ROUTE_LANG_STUDIO,
    ROUTE_LANG_TEAM,
    ROUTE_LANG_VISION,
    ROUTE_LOGIN,
    ROUTE_MEMBER,
} from '../Routes'
import Home from '@mui/icons-material/Home'
import ListItemIcon from '@mui/material/ListItemIcon'
import BookSharp from '@mui/icons-material/BookSharp'
import EuroSharp from '@mui/icons-material/EuroSharp'
import FitnessCenterSharp from '@mui/icons-material/FitnessCenterSharp'
import GroupSharp from '@mui/icons-material/GroupSharp'
import HomeWorkSharp from '@mui/icons-material/HomeWorkSharp'
import InfoSharp from '@mui/icons-material/InfoSharp'
import LockOpenSharp from '@mui/icons-material/LockOpenSharp'
import LockSharp from '@mui/icons-material/LockSharp'
import MailSharp from '@mui/icons-material/MailSharp'
import QuestionAnswerSharp from '@mui/icons-material/QuestionAnswerSharp'
import AccountCircleSharpIcon from '@mui/icons-material/AccountCircleSharp'
import useUser from '../api/auth/useUser'
import {useRouter} from 'next/navigation'
import fetchJson from '../api/auth/fetchJson'

function SideContent() {
    const {getT} = useTranslation()

    const {user, mutateUser} = useUser()
    const router = useRouter()

    return (
        <>
            <List className='sidecontent-list'>
                <Link href={ROUTE_HOME} className='link-decoration__sidecontent'>

                    <ListItem key={crypto.randomUUID()}>
                        <ListItemIcon>
                            <Home />
                        </ListItemIcon>
                        <ListItemText primary={getT('links.home.name')} />
                    </ListItem>

                </Link>

                <Link
                    href={ROUTE_LANG_PRICING}
                    className='link-decoration__sidecontent'
                >

                    <ListItem key={crypto.randomUUID()}>
                        <ListItemIcon>
                            <EuroSharp />
                        </ListItemIcon>
                        <ListItemText primary={getT('links.pricing.name')} />
                    </ListItem>

                </Link>
                <Link href={ROUTE_BLOG} className='link-decoration__sidecontent'>

                    <ListItem key={crypto.randomUUID()}>
                        <ListItemIcon>
                            <BookSharp />
                        </ListItemIcon>
                        <ListItemText primary={getT('links.blogs.all.name')} />
                    </ListItem>

                </Link>

            </List>

            <Divider />

            <List className='sidecontent-list'>
                <Link
                    href={ROUTE_LANG_COURSES}
                    className='link-decoration__sidecontent'
                >

                    <ListItem key={crypto.randomUUID()}>
                        <ListItemIcon>
                            <FitnessCenterSharp />
                        </ListItemIcon>
                        <ListItemText primary={getT('links.courses.name')} />
                    </ListItem>

                </Link>
                <Link
                    href={ROUTE_LANG_FITNESS}
                    className='link-decoration__sidecontent'
                >

                    <ListItem key={crypto.randomUUID()}>
                        <ListItemIcon>
                            <QuestionAnswerSharp />
                        </ListItemIcon>
                        <ListItemText primary={getT('links.fitness.name')} />
                    </ListItem>

                </Link>
                <Link
                    href={ROUTE_LANG_STUDIO}
                    className='link-decoration__sidecontent'
                >

                    <ListItem key={crypto.randomUUID()}>
                        <ListItemIcon>
                            <HomeWorkSharp />
                        </ListItemIcon>
                        <ListItemText primary={getT('links.studio.name')} />
                    </ListItem>

                </Link>
                <Link
                    href={ROUTE_LANG_TEAM}
                    className='link-decoration__sidecontent'
                >

                    <ListItem key={crypto.randomUUID()}>
                        <ListItemIcon>
                            <GroupSharp />
                        </ListItemIcon>
                        <ListItemText primary={getT('links.team.name')} />
                    </ListItem>

                </Link>
                <Link
                    href={ROUTE_LANG_VISION}
                    className='link-decoration__sidecontent'
                >

                    <ListItem key={crypto.randomUUID()}>
                        <ListItemIcon>
                            <GroupSharp />
                        </ListItemIcon>
                        <ListItemText primary={getT('links.vision.name')} />
                    </ListItem>

                </Link>
            </List>

            <Divider />

            <List className='sidecontent-list'>
                <Link
                    href={ROUTE_LANG_CONTACT}
                    className='link-decoration__sidecontent'
                >

                    <ListItem key={crypto.randomUUID()}>
                        <ListItemIcon>
                            <MailSharp />
                        </ListItemIcon>
                        <ListItemText primary={getT('links.contact.name')} />
                    </ListItem>

                </Link>
                <Link
                    href={ROUTE_LANG_PRIVACY}
                    className='link-decoration__sidecontent'
                >

                    <ListItem key={crypto.randomUUID()}>
                        <ListItemIcon>
                            <LockSharp />
                        </ListItemIcon>
                        <ListItemText primary={getT('links.privacy.name')} />
                    </ListItem>

                </Link>
                <Link
                    href={ROUTE_LANG_IMPRINT}
                    className='link-decoration__sidecontent'
                >

                    <ListItem key={crypto.randomUUID()}>
                        <ListItemIcon>
                            <InfoSharp />
                        </ListItemIcon>
                        <ListItemText primary={getT('links.imprint.name')} />
                    </ListItem>

                </Link>
            </List>

            <Divider />

            <List className='sidecontent-list'>
                <Link
                    href={ROUTE_MEMBER}
                    className='link-decoration__sidecontent'
                >
                    <ListItem key={crypto.randomUUID()}>
                        <ListItemIcon>
                            <AccountCircleSharpIcon />
                        </ListItemIcon>
                        <ListItemText primary='Member Area' />
                    </ListItem>
                </Link>

                {!user?.isLoggedIn && (
                    (<Link
                        href={ROUTE_LOGIN}
                        className='link-decoration__sidecontent'
                    >

                        <ListItem key={crypto.randomUUID()}>
                            <ListItemIcon>
                                <LockOpenSharp />
                            </ListItemIcon>
                            <ListItemText primary={getT('links.user.login.name')} />
                        </ListItem>

                    </Link>)
                )}
                {user?.isLoggedIn && (
                    <a className='link-decoration__sidecontent'
                       onClick={async (e) => {
                           e.preventDefault()
                           await mutateUser(
                               await fetchJson('/api/logout', {method: 'POST'}),
                               false,
                           )
                           router.push('/login')
                       }}>
                        <ListItem key={crypto.randomUUID()} style={{cursor: 'pointer'}}>
                            <ListItemIcon>
                                <LockOpenSharp />
                            </ListItemIcon>
                            <ListItemText primary={getT('links.user.logout.name')} />
                        </ListItem>
                    </a>
                )}
            </List>
        </>
    );
}

export default memo(SideContent)
